import { createFileRoute } from '@tanstack/react-router';

import { StudyReview } from '@/features/imaging';
export const Route = createFileRoute('/_authenticated/imaging/$studyId')({ component: Page });
function Page() {
  const { studyId } = Route.useParams();
  return <StudyReview studyId={studyId} />;
}
